<template>
  <div>
    <div v-if="quoteHasRejectedStatus()" class="rejectedStatus">
      <p class="m-message-bar m-message-bar--warning">
        {{ i18n.t('/dashboard/quotes/rejected/title') }}
      </p>

      <div class="m-message-bar m-message-bar--warning">
        <p>
          {{ i18n.t('/dashboard/quotes/rejected/text') }}
          <br />
          {{ quote.QuoteDetails.Reason }}
        </p>
      </div>
    </div>

    <div v-if="!configurationIsValid" v-show="!hidden">
      <p v-if="closable" class="configuration-status__close-wrapper" @click="hidden = true">
        Sluit meldingen
        <icon class="configuration-status__close-icon" icon="cross" />
      </p>

      <p
        v-if="quote.QuoteDetails.Cars[0].Type === 'CONFIGURATION' && !statusDetails?.Title"
        class="m-message-bar m-message-bar--warning"
      >
        {{ i18n.t('/Configuration/ConfigurationInvalid') }}
      </p>
      <div v-if="statusDetails" class="m-message-bar m-message-bar--warning u-dont-break-out">
        <p>
          {{ statusDetails.Title }}<br />
          <template v-for="(item, index) in statusDetails.Body" :key="index">
            {{ item }}<br />
          </template>
          <a :href="statusDetails.LinkHref" target="_blank">{{ statusDetails.LinkText }}</a>
        </p>
      </div>

      <div
        v-for="(validationMessage, index) in validationMessages"
        :key="index"
        class="m-message-bar m-message-bar--warning configuration-status__validation-messages"
      >
        <span v-if="validationMessage.Title" class="configuration-status__title">
          {{ validationMessage.Title }}
        </span>
        <p
          v-for="(body, bodyIndex) in validationMessage.Body"
          :key="bodyIndex"
          class="configuration-status__body"
        >
          {{ body }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import StoreConnector from '@/helpers/StoreConnector'
import { mapGetters } from 'vuex'

export default {
  components: {
    Icon,
  },
  props: {
    closable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      statusDetails: null,
      configurationIsValid: true,
      hidden: false,
      validationMessages: [],
    }
  },
  computed: {
    ...mapGetters({
      quote: 'quote/get',
    }),
  },
  created() {
    StoreConnector.get('configuration/status', (data) => {
      if (!data) {
        return
      }

      this.configurationIsValid = data.IsValid
      this.statusDetails = data.InvalidInfo?.InvalidMessageUser
    })

    StoreConnector.get('quote/validationMessages', (validationMessages) => {
      if (validationMessages) {
        if (validationMessages.length > 0) {
          this.configurationIsValid = false
          this.validationMessages = validationMessages
        }
      }
    })
  },
  methods: {
    quoteHasRejectedStatus() {
      return this.quote.Status === 'REJECTED'
    },
  },
}
</script>

<style lang="scss" scoped>
div.m-message-bar--warning {
  margin-bottom: 1em;
}

.configuration-status {
  &__close {
    &-wrapper {
      text-align: center;
      font-weight: bolder;
      color: white;
      background-color: #fc8826;
      margin-bottom: 0;
      cursor: pointer;
      padding-top: 0.5rem;
    }

    &-icon {
      padding-top: 0.1rem;
      height: 16px;
      width: 16px;
    }
  }

  &__body {
    margin: 0 2em;
  }

  &__validation-messages > p,
  &__validation-messages > span {
    width: 100%;
  }
}

.rejectedStatus {
  margin-bottom: 30px;
}
</style>
